import { Injectable } from '@angular/core';

@Injectable()
export class TradingPartnerTodoService {

  constructor () { }



  // moveContainer(event: any, containerIndex: number) {
  //   this.setContainerSeqNum(this.containers);
  //   console.log(this.containers);
  //   this.dataService.updateLanes(classToPlain(this.containers, { excludePrefixes: ['widgets'] })).subscribe(res => {
  //     if (res) {
  //       for (let r of res) {
  //         r.widgets = [];
  //         for (let w of this.widgets) {
  //           if (r.id == w.taskLaneId) {
  //             r.widgets.push(w);
  //           }
  //         }
  //         r.widgets.sort(this.compare);                    //sorting widgets in containers
  //       }
  //       this.containers = plainToClass(Container, res);
  //       this.containers.sort(this.compare);
  //     }
  //   });
  // }


  // //setting sequence number for containers
  // setContainerSeqNum(containers: Array<Container>) {
  //   for (let c = 0; c < containers.length; c++) {
  //     containers[c].sequenceNum = c;
  //   }
  // }

  // compare(a, b) {
  //   if (a.sequenceNum < b.sequenceNum) {
  //     return -1;
  //   }
  //   else if (a.sequenceNum == b.sequenceNum) {
  //     return 0;
  //   }
  //   else {
  //     return 1;
  //   }
  // }




  //------------------------

  pushWidgetsToContainers(widgets, containers) {
    // assume this.containers is properly initialized with c.widgets = []
    for (let w of widgets) {
      console.log("processing widget id = ", w.id);
      for (let c of containers) {
        if (c.id === w.taskLaneId) {
          console.warn("match found");
          this.pushWidgetInOrder(w, c.widgets);
          // c.widgets.push(w);   // without sorting
          console.warn("widgets");
          break;
        }
      }
    }
    return containers;
  }

  pushWidgetInOrder(widget, widgets) {
    if (!widgets) {
      widgets = [];
      widgets.push(widget);
      return widgets;
    }
    widgets.splice(this.locationOfWidget(widget, widgets) + 1, 0, widget);
    return widgets;
  }

  locationOfWidget(widget, widgets, start?, end?) {
    start = start || 0;
    end = end || widgets.length;
    let pivot = parseInt(start + (end - start) / 2, 10);
    console.log(`pivot = ${pivot}. widgets and widget = `);
    console.log(widgets);
    console.log(widget);

    if (!widgets[pivot] || widgets[pivot].sequenceNum === widget.sequenceNum) {
      return pivot;
    }
    if (end - start <= 1) {
      return widgets[pivot].sequenceNum > widget.sequenceNum ? pivot - 1 : pivot;
    }
    if (widgets[pivot].sequenceNum < widget.sequenceNum) {
      return this.locationOfWidget(widget, widgets, pivot, end);
    } else {
      return this.locationOfWidget(widget, widgets, start, pivot);
    }
  }







}
